import script from "./DailyCust.vue?vue&type=script&setup=true&lang=ts"
export * from "./DailyCust.vue?vue&type=script&setup=true&lang=ts"

import "./DailyCust.vue?vue&type=style&index=0&id=e80bd164&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/运营辅助平台正式前端/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e80bd164"]])

export default __exports__